export default __webpack_public_path__ + "static/media/pillarofinfernalflame3.63432f0f.png";